import { forEach, filter, remove, slice, includes, cloneDeep } from 'lodash';
import app from '../../angular_app.es6';

app.controller('ConfigClaimsController',
  [ '$scope', 'Notification', '$timeout', '$http', '$element', '$interval', '$rootScope', '$location', 'PasteTableService',
    ($scope, Notification, $timeout, $http, $element, $interval, $rootScope, $location, PasteTableService) => {
      const forceEditParam = 'edit',
        checkInterval = 5000;
      let checkEvery5s = null;
      $scope.newClaim = {};

      $scope.form = {};
      $scope.source_form = {};
      $scope.options = {
        possible_concepts_modes: []
      };

      $scope.init = (data, options, notification) => {
        $rootScope.$broadcast('hideExamples');

        $scope.form = cloneDeep(data);
        $scope.source_form = data;
        $scope.options = options;
        $scope.notification = notification;
        $scope.asyncGenerateJID = $scope.options.jid;

        if ($scope.asyncGenerateJID) {
          checkEvery5s = $interval($scope.checkAsyncGenerate, checkInterval);
          $rootScope.$broadcast('disableNavButtons');
        }

        if ($scope.notification) {
          Notification.error($scope.notification);
        }
        $scope.refreshTempItem();
      };

      $scope.isCurrentModeMaxDiff = () => (
        $scope.form.concepts_mode === 'maxdif' || $scope.form.concepts_mode === 'maxdif_turf'
      );

      $scope.conceptsModeEnabled = () => includes(
        $scope.options.possible_concepts_modes, $scope.form.concepts_mode
      );

      $scope.refreshTempItem = () => {
        $scope.newClaim = {
          id: null,
          label: null,
          text: null
        };
      };

      $scope.noClaims = () => {
        const emptyList = !$scope.notDeletedClaims().length;
        if (emptyList) {
          $rootScope.$broadcast('hideExamples');
        } else {
          $rootScope.$broadcast('showExamples');
        }
        return emptyList;
      };

      $scope.isEditing = () => (!$scope.noClaims() || !!$location.search()[forceEditParam]);

      $scope.startEdit = () => {
        $location.search(forceEditParam, '1');
      };

      $scope.addClaim = (event) => {
        event.preventDefault();
        $scope.form.express_claims.push($scope.newClaim);
        $scope.refreshTempItem();
      };

      $scope.destroyClaim = (event, claim) => {
        event.preventDefault();
        if (claim.id) {
          claim._destroy = true;
        } else {
          remove($scope.form.express_claims, claim);
        }
      };

      $scope.notDeletedClaims = () => (
        filter($scope.form.express_claims, (claim) => (!claim._destroy))
      );

      $scope.hasLabelError = (claim) => (claim.errors && !!claim.errors.label);

      $scope.hasTextError = (claim) => (claim.errors && !!claim.errors.text);

      $scope.$on('xlsx-loaded', (ev, arr) => {
        const newElms = [];

        forEach(arr, (el) => {
          let text = el[arr.headerStatement], label = el[arr.headerLabel];

          if (text) {
            label = label == undefined ? '' : label.toString();
            text = text.toString();

            newElms.push(
              {
                id: null,
                text: slice(text, 0, $scope.form.max_text_len).join(''),
                label: slice(label, 0, $scope.form.max_label_len).join('')
              }
            );
          }
        });

        $timeout(() => {
          forEach(
            newElms,
            (el) => { $scope.form.express_claims.push(el); }
          );
        });
      });

      // private

      $scope.checkAsyncGenerate = () => {
        $http.get($scope.options.check_status_url).then(
          (success) => {
            if (success.data.status === "finished") {
              $interval.cancel(checkEvery5s);
              $scope.asyncGenerateJID = null;
              window.location.href = $scope.options.next_step_url;
            } else if (success.data.status === "failed") {
              $scope.asyncGenerateJID = null;
              $interval.cancel(checkEvery5s);
              Notification.error("Project rebuilding failed.");
              $rootScope.$broadcast('enableNavButtons');
            }
          },
          (reject) => {
            $interval.cancel(checkEvery5s);
            $scope.asyncGenerateJID = null;
            console.log('checkAsyncGenerate', reject);
            $rootScope.$broadcast('enableNavButtons');
          }
        );
      };

      $scope.$on('project-form-next-step', (event) => {
        if ($scope.asyncGenerateJID) {
          event.preventDefault();
          Notification.error("Rebuilding in progress.");
          return;
        }

        if (!trackChanges() && trackExisting() && !$scope.notification) {
          event.preventDefault();
          window.location.href = $scope.options.next_step_url;
        } else {
          const $form = $('#config_form');
          if (!trackExisting()) {
            $form.submit();
          } else if (confirm($scope.options.change_structure_message)) {
            $form.submit();
          }
        }
      });

      const trackExisting = () => (
        !!filter($scope.form.express_claims, (el) => !!el.id).length
      );

      const trackChanges = () => (!angular.equals($scope.form, $scope.source_form));

      $scope.onPaste = ($e, index) => {
        const lines = PasteTableService.extract($e);
        if (lines != null) {
          PasteTableService.apply(
            index,
            $scope.notDeletedClaims(),
            [ 'text', 'label' ],
            lines,
            $scope.form.express_claims,
            $scope.form.max,
            () => ({ id: null, text: null, label: null })
          );
        }
      };
    } ]);
